import { forwardRef, type Ref, type SVGProps } from "react";
const IconVolumeMidOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M16.758 6.765c.351.17.576.536.576.939v16.592c0 .403-.225.769-.576.94a.97.97 0 0 1-1.065-.143l-5.722-4.945H6.334c-.553 0-1-.464-1-1.037V12.89c0-.573.447-1.037 1-1.037H9.97l5.722-4.945a.97.97 0 0 1 1.065-.142m-1.424 3.153-4.36 3.768a.98.98 0 0 1-.64.24h-3v4.148h3c.233 0 .46.085.64.24l4.36 3.768zm4.093 4.052h-.002a1 1 0 1 1 .486-1.94c.633.157 1.305.694 1.793 1.313.516.656.964 1.576.964 2.656s-.448 2-.964 2.656c-.488.619-1.16 1.156-1.793 1.314a1 1 0 0 1-.486-1.94l.002-.001c.016-.007.099-.041.235-.143a2.6 2.6 0 0 0 .47-.467c.317-.403.536-.9.536-1.419 0-.52-.219-1.016-.536-1.419a2.6 2.6 0 0 0-.47-.467 1 1 0 0 0-.235-.143"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconVolumeMidOutlineSVG);
ForwardRef.displayName = "IconVolumeMidOutline";
export { ForwardRef as IconVolumeMidOutline };
